import { createContext, useContext, useState } from 'react';

const AUTH_STORAGE_KEY = 'auth';

function readFromStorage() {
    try {
        const raw = localStorage.getItem(AUTH_STORAGE_KEY);
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [auth, setAuth] = useState(() => readFromStorage());

    function login(session) {
        const data = {
            token:         session.token ?? null,
            nombreUsuario: session.nombreUsuario,
            nombre:        session.nombre ?? null,
            rol:           session.rol.toLowerCase(),
            usuarioId:     session.usuarioId,
            ...(session.medicoId ? { medicoId: session.medicoId } : {}),
        };
        localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(data));
        setAuth(data);
    }

    function logout() {
        localStorage.removeItem(AUTH_STORAGE_KEY);
        setAuth(null);
    }

    function updateSession(partial) {
        setAuth(prev => {
            if (!prev) return prev;
            const next = { ...prev, ...partial };
            localStorage.setItem(AUTH_STORAGE_KEY, JSON.stringify(next));
            return next;
        });
    }

    return (
        <AuthContext.Provider value={{ user: auth, token: auth?.token ?? null, login, logout, updateSession }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    const ctx = useContext(AuthContext);
    if (!ctx) throw new Error('useAuth debe usarse dentro de AuthProvider');
    return ctx;
}
